import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { DisputeProvider } from './context/DisputeContext';

// Party A Pages
import StartPage from './pages/PartyA/StartPage';
import ClassifyPage from './pages/PartyA/ClassifyPage';
import AssessmentPage from './pages/PartyA/AssessmentPage';
import ParametersPage from './pages/PartyA/ParametersPage';
import InvitePage from './pages/PartyA/InvitePage';
import StatusPage from './pages/PartyA/StatusPage';
import FeedbackPage from './pages/PartyA/FeedbackPage';

// Party B Pages
import RespondLandingPage from './pages/PartyB/RespondLandingPage';
import PreparePage from './pages/PartyB/PreparePage';
import RespondAssessmentPage from './pages/PartyB/RespondAssessmentPage';
import RespondParametersPage from './pages/PartyB/RespondParametersPage';
import SettlementPage from './pages/PartyB/SettlementPage';

// Attorney Pages
import LoginPage from './pages/attorney/LoginPage';
import DashboardPage from './pages/attorney/DashboardPage';
import CaseReviewPage from './pages/attorney/CaseReviewPage';
import AnalyticsPage from './pages/attorney/AnalyticsPage';

// Settlement Pages
import SettlementReviewPage from './pages/SettlementReviewPage';

// Payment Pages
import PaymentPage from './pages/PaymentPage';

// Shared Components
import Layout from './components/Layout';
import NotFound from './pages/NotFound';

function App() {
  return (
    <DisputeProvider>
      <Layout>
        <Routes>
          {/* Party A Routes */}
          <Route path="/" element={<StartPage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/classify" element={<ClassifyPage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/parameters" element={<ParametersPage />} />
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />

          {/* Party B Routes */}
          <Route path="/respond/:token" element={<RespondLandingPage />} />
          <Route path="/respond/:token/prepare" element={<PreparePage />} />
          <Route path="/respond/:token/assessment" element={<RespondAssessmentPage />} />
          <Route path="/respond/:token/parameters" element={<RespondParametersPage />} />
          <Route path="/respond/:token/settlement" element={<SettlementPage />} />

          {/* Attorney Routes */}
          <Route path="/attorney/login" element={<LoginPage />} />
          <Route path="/attorney/dashboard" element={<DashboardPage />} />
          <Route path="/attorney/case/:id" element={<CaseReviewPage />} />
          <Route path="/attorney/analytics" element={<AnalyticsPage />} />

          {/* Settlement Routes */}
          <Route path="/settlement/:disputeId" element={<SettlementReviewPage />} />

          {/* Payment Routes */}
          <Route path="/payment/:paymentId" element={<PaymentPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </DisputeProvider>
  );
}

export default App;
